<template>
  <div v-if="!isLoading && venueCampaign && activeVenue">
    <vs-breadcrumb class="mt-2">
      <li>
        <router-link to="/vp/venuecampaigns">Campaigns</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="active">Fill out campaign</li>
    </vs-breadcrumb>

    <vs-tabs
      position="left"
      class="tabs-shadow-none mt-2"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <vs-tab
        icon-pack="feather"
        icon="icon-zap"
        :label="!isSmallerScreen ? 'General' : ''"
      >
        <div class="lists-view-tab">
          <venue-campaign-general
            :venue-campaign="venueCampaign"
            v-on:onSubmit="onSubmit"
            v-on:onReset="onReset"
            v-on:onSave="onClickSave"
            v-on:onPreview="onClickPreview"
            v-on:onRetractSubmission="onRetractSubmission"
            :isEditable="
              isEditable &&
              hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')
            "
          />
        </div>
      </vs-tab>
      <vs-tab
        :disabled="!hasEmail"
        v-if="hasEmail || !venueCampaign.isBasedOnMasterCampaign"
        icon-pack="feather"
        icon="icon-mail"
        :label="!isSmallerScreen ? 'Email' : ''"
      >
        <div class="lists-view-tab">
          <venue-campaign-email
            :venue-campaign="venueCampaign"
            v-on:onSave="onClickSave"
            :isEditable="
              isEditable &&
              hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')
            "
          />
        </div>
      </vs-tab>
      <vs-tab
        :disabled="!hasSms"
        v-if="hasSms || !venueCampaign.isBasedOnMasterCampaign"
        icon-pack="feather"
        icon="icon-smartphone"
        :label="!isSmallerScreen ? 'Sms' : ''"
      >
        <div class="lists-view-tab">
          <venue-campaign-sms
            :venue-campaign="venueCampaign"
            v-on:onSave="onClickSave"
            :isEditable="
              isEditable &&
              hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')
            "
          />
        </div>
      </vs-tab>
      <vs-tab
        :disabled="!hasNpPush"
        v-if="hasNpPush || !venueCampaign.isBasedOnMasterCampaign"
        icon-pack="feather"
        icon="icon-bell"
        :label="!isSmallerScreen ? 'NightPay Push' : ''"
      >
        <div class="lists-view-tab">
          <venue-campaign-nightpay-push
            :venue-campaign="venueCampaign"
            v-on:onSave="onClickSave"
            :isEditable="
              isEditable &&
              hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')
            "
          />
        </div>
      </vs-tab>
      <!-- TODO Disabled -->
      <vs-tab
        :disabled="
          true ||
          (!venueCampaign.hasSentEmail &&
            !venueCampaign.hasSentNpPush &&
            !venueCampaign.hasSentSms)
        "
        icon-pack="feather"
        icon="icon-pie-chart"
        :label="!isSmallerScreen ? 'Statistics' : ''"
      >
        <div class="lists-view-tab">
          <venue-campaign-stats :venue-campaign="venueCampaign" />
        </div>
      </vs-tab>

      <vs-tab
        icon-pack="feather"
        icon="icon-alert-triangle"
        :label="!isSmallerScreen ? 'Danger Zone' : ''"
        v-if="hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')"
      >
        <div class="lists-view-tab">
          <venue-campaign-danger-zone
            :venue-campaign="venueCampaign"
            v-on:onSave="$emit('onSave')"
            :isEditable="isEditable"
          />
        </div>
      </vs-tab>
    </vs-tabs>

    <preview-popup ref="previewPopup" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VenueCampaignGeneral from "./Components/VenueCampaignGeneral.vue";
import VenueCampaignEmail from "./Components/VenueCampaignEmail.vue";
import VenueCampaignSms from "./Components/VenueCampaignSms.vue";
import VenueCampaignNightpayPush from "./Components/VenueCampaignNightpayPush.vue";
import VenueCampaignStats from "./Components/VenueCampaignStats.vue";
import VenueCampaignDangerZone from "./Components/VenueCampaignDangerZone.vue";
import EmailTemplateEditor from "@/components/EmailTemplateEditor/EmailTemplateEditor.vue";
import PreviewPopup from "../../crm/Campaigns/Components/MasterCampaign/PreviewCampaignPopup.vue";

export default {
  components: {
    EmailTemplateEditor,
    VenueCampaignGeneral,
    VenueCampaignEmail,
    VenueCampaignSms,
    VenueCampaignNightpayPush,
    VenueCampaignStats,
    VenueCampaignDangerZone,
    PreviewPopup,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  async mounted() {},
  methods: {
    // clickRoute(routeName) {
    //   this.$router.replace({ name: "lists", params: { listname: routeName } });
    // },
    async onClickSave() {
      console.log("Clicked save", this.venueCampaign);

      //Call service
      try {
        this.$vs.loading();
        await this.$store.dispatch("venueCampaigns/update", this.venueCampaign);
        this.$vs.notify({
          color: "green",
          title: "Campaign updated",
          text: "The campaign was successfully updated",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Campaign could not update",
          text: err,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    onReset() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to reset this Campaign? The email and sms content will be removed and reset to the original template from the Master Campaign.",
        accept: async () => {
          try {
            this.$vs.loading();
            await this.$store.dispatch(
              "venueCampaigns/resetFromMaster",
              this.venueCampaign.id
            );
            this.$vs.notify({
              color: "green",
              title: "Campaign reset",
              text: "The campaign was successfully reset",
            });
          } catch (err) {
            console.error(err);

            this.$vs.notify({
              color: "danger",
              title: "Campaign reset error",
              text: err,
            });
          } finally {
            this.$vs.loading.close();
          }
        },
      });
    },

    // When submitting for approval
    async onSubmit(comment) {
      try {
        this.$vs.loading();
        await this.$store.dispatch("venueCampaigns/submitForApproval", {
          venueCampaignId: this.venueCampaign.id,
          comment: comment,
        });
        this.$vs.notify({
          color: "green",
          title: "Campaign submitted",
          text: "The campaign was successfully submitted for approval",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Campaign submit error",
          text: err,
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    // When retracting the submission for approval
    async onRetractSubmission() {
      try {
        this.$vs.loading();
        await this.$store.dispatch("venueCampaigns/retractSubmission", {
          venueCampaignId: this.venueCampaign.id,
        });
        this.$vs.notify({
          color: "green",
          title: "Campaign submission retracted",
          text: "The campaign submission was successfully retracted",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Campaign submission retract error",
          text: err,
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async onClickPreview() {
      this.$refs.previewPopup.show(this.venueCampaign, null, false);
    },
  },
  computed: {
    ...mapGetters({
      venueCampaign: "venueCampaigns/venueCampaign",
      activeVenue: "venues/activeVenue",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    isEditable() {
      return (
        this.venueCampaign.status == "ReadyToFillOut" ||
        this.venueCampaign.status == "Rejected"
      );
    },
    hasEmail() {
      return this.venueCampaign.hasEmail;
    },
    hasSms() {
      return this.venueCampaign.hasSms;
    },
    hasNpPush() {
      return this.venueCampaign.hasNpPush;
    },
  },
  async created() {
    var venueCampaignId = this.$route.params.id;

    this.isLoading = true;
    await this.$store.dispatch("venueCampaigns/get", venueCampaignId);
    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.lists-view-tab {
  margin-left: 12px;
}
</style>
